"use strict";

exports.__esModule = true;
exports.default = void 0;

var getAcronym = function getAcronym(name) {
  var acronymChars = name.split(' ').map(function (str) {
    return str.match(/[A-Za-z]/);
  });
  return acronymChars.slice(0, 3).join('').toUpperCase();
};

var _default = getAcronym;
exports.default = _default;